import React, { useEffect } from 'react';
import { produce } from 'immer';
import { useLocation } from "@remix-run/react";
import { useViewport } from '../../providers/ViewportProvider/ViewportContext';
import { logAction } from '../../utils/log-action';
import { jsx as _jsx } from "react/jsx-runtime";
export const initialState = {
  dialogs: [],
  closeAll: false
};
const MobileDialogContext = /*#__PURE__*/React.createContext(undefined);
const MobileDialogDispatchContext = /*#__PURE__*/React.createContext(undefined);
export const reducer = (state, action) => {
  logAction(state, action);
  return produce(state, draft => {
    switch (action.type) {
      case 'register':
        {
          if (draft.dialogs.includes(action.dialogId)) {
            throw new Error(`Can not show two MobileDialogs with the same ID: ${action.dialogId}`);
          }
          draft.dialogs.push(action.dialogId);
          draft.closeAll = false;
          return draft;
        }
      case 'unregister':
        {
          draft.dialogs = draft.dialogs.filter(dialogId => dialogId !== action.dialogId);
          return draft;
        }
      case 'close':
        {
          draft.dialogs.pop();
          return draft;
        }
      case 'close-all':
        {
          draft.dialogs = [];
          draft.closeAll = true;
          return draft;
        }
      default:
        {
          throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
  });
};
export const MobileDialogProvider = ({
  children
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const {
    isSmall
  } = useViewport();
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    if (!isSmall || pathname) {
      dispatch({
        type: 'close-all'
      });
    }
  }, [isSmall, dispatch, pathname]);
  return /*#__PURE__*/_jsx(MobileDialogContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(MobileDialogDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
};
export const useMobileDialogState = () => {
  const context = React.useContext(MobileDialogContext);
  if (context === undefined) {
    throw new Error('useMobileDialogState must be used within a MobileDialogProvider');
  }
  return context;
};
export const useMobileDialogDispatch = () => {
  const context = React.useContext(MobileDialogDispatchContext);
  if (context === undefined) {
    throw new Error('useMobileDialogDispatch must be used within a MobileDialogProvider');
  }
  return context;
};